// 대시보드 관련 상수들
export const DASHBOARD_CONFIG = {
  PAGE_SIZE: 10,
  START_DATE: "2023-11-13",
  EXIT_START_DATE: "2024-06-13",
  INITIAL_TOTAL_GAME_MONEY: 800000000,
  INITIAL_TOTAL_MANUAL_GAME_MONEY: 880155000,
} as const;

// 테이블 헤더 정의
export const DASHBOARD_HEADERS: any = [
  { text: "Date", align: "center", sortable: false, value: "date" },
  { text: "신규가입", align: "center", sortable: false, value: "userCount" },
  { text: "탈퇴", align: "center", sortable: false, value: "exitUserCount" },
  {
    text: "당일탈퇴",
    align: "center",
    sortable: false,
    value: "dayExitUserCount",
  },
  {
    text: "친구추천",
    align: "center",
    sortable: false,
    value: "dailyRecommendCount",
  },
  {
    text: "친추 생성 GP",
    align: "center",
    sortable: false,
    value: "gameMoney",
  },
  {
    text: "수동 지급 GP",
    align: "center",
    sortable: false,
    value: "manualGameMoney",
  },
  {
    text: "상금 지급 GP",
    align: "center",
    sortable: false,
    value: "prizeGameMoney",
  },
  {
    text: "쿠폰 지급 GP",
    align: "center",
    sortable: false,
    value: "couponGameMoney",
  },
  {
    text: "출석 지급 GP",
    align: "center",
    sortable: false,
    value: "attendancePoint",
  },
  {
    text: "무료 충전 GP",
    align: "center",
    sortable: false,
    value: "freeCharge",
  },
  {
    text: "신규 가입 GP",
    align: "center",
    sortable: false,
    value: "newUserBonus",
  },
  { text: "클럽 가입 GP", align: "center", sortable: false, value: "clubJoin" },
] as const;

// 상품명과 포인트/리바이 매핑
export const PRODUCT_POINT_MAP = {
  "게임포인트 200,000 골드": { gameMoney: 200000, rebuy: 0 },
  "게임포인트 100,000 골드": { gameMoney: 100000, rebuy: 0 },
  "게임포인트 50,000 골드": { gameMoney: 50000, rebuy: 0 },
  "게임포인트 30,000 골드": { gameMoney: 30000, rebuy: 0 },
  "게임포인트 10,000 골드": { gameMoney: 30000, rebuy: 0 }, // 원본 코드에서 30000으로 되어있음
  "게임포인트 1,000 골드": { gameMoney: 1000, rebuy: 0 },
  "리바인권 1개": { gameMoney: 0, rebuy: 1 },
  "리바인권 2개": { gameMoney: 0, rebuy: 2 },
} as const;
